<template>
	<div class="p-6 bg-gray-50 min-h-screen">
		<GlobalLoader :is-loading="isLoading" />
		<section class="mb-8">
			<div class="flex justify-between items-center mb-4">
				<h4 class="text-lg font-semibold text-gray-800">Analytics & Reporting</h4>
				<button class="flex items-center text-sm text-blue-600 hover:text-blue-700" @click="handleRefresh">
					<q-icon name="rotate_right" size="md" :class="[
						'transition-transform duration-700',
						isRotating ? 'rotate-180' : ''
					]" />
					<span class="ml-1">Refresh Data</span>
				</button>
			</div>

			<DashboardCard title="Weekly Entries" subtitle="Total submitted user entries per gameweek" :has-docs="true">
				<BarChart :data="weeklyEntriesData" />
			</DashboardCard>

			<DashboardCard title="Revenue vs Payout" subtitle="Financial performance comparison" :has-docs="true"
				class="mt-6">
				<RevenuePayouts :data="revenuePayoutsData" />
			</DashboardCard>
		</section>

		<!-- <section class="mb-8">
			<DashboardCard title="Total Prize Pool" subtitle="Current prize pool status and breakdown" :has-docs="true">
				<PrizePool :data="prizePoolData" />
			</DashboardCard>
		</section> -->

		<section>
			<div class="grid grid-cols-2 md:grid-cols-4 gap-4">
				<MetricBox icon-type="players" title="Players Participated" :value="revenuePayoutsData.total_players" />
				<MetricBox icon-type="winners" title="Weekly Winners" :value="revenuePayoutsData.total_winners" />
				<MetricBox icon-type="winrate" title="Win Rate" :value="revenuePayoutsData.winrate" />
				<MetricBox icon-type="gameweeks" title="Active Gameweeks" :value="revenuePayoutsData.active_game_weeks" />
			</div>
		</section>
	</div>
</template>

<script setup>
import DashboardCard from '../components/DashboardCard.vue';
import BarChart from '../components/BarChart.vue';
import RevenuePayouts from '../components/RevenuePayouts.vue';
import PrizePool from '../components/PrizePool.vue';
import MetricBox from '../components/MetricBox.vue';
import { onMounted, ref } from 'vue';
import GlobalLoader from '../components/GlobalLoader.vue';

// Dummy Data
const weeklyEntriesData = ref([]);
const revenuePayoutsData = ref({});
const prizePoolData = ref({});
const isRotating = ref(false);
const isLoading = ref(false);

onMounted(() => {
	getAnalyticsData();
})

const getAnalyticsData = async () => {
	try {
		isLoading.value = true
		const data = await fetch('/admin/analytics', {
			method: 'GET',
		});

		const val = await data.json();
		console.log("🚀 ~ getAnalyticsData ~ val:", val);
		if (val) {
			weeklyEntriesData.value = val.weekly_entries;
			revenuePayoutsData.value = val.revenue_payout;
			prizePoolData.value = val.weekly_prize_info.prize_info;
		}
	} catch (error) {
		console.log("🚀 ~ getAnalyticsData ~ error:", error);
	} finally {
		isLoading.value = false
	}
}

const handleRefresh = () => {
	isRotating.value = true
	getAnalyticsData()
	// simulate refresh process
	setTimeout(() => {
		isRotating.value = false
	}, 700) // same as duration above
}
</script>